// MODE
export const GATED_BASE_KEY = "gated"
export const PARK_BASE_KEY = "park"
export const RESERVE_BASE_KEY = "reserve"
export const PASSES_BASE_KEY = "passes"

// SHARED
export const SHARED_BASE_KEY = "shared"
export const RECEIPT_BASE_KEY = "receipt"
export const REGISTER_BASE_KEY = "register"
export const THEME_BASE_KEY = "theme"
export const SESSION_BASE_KEY = "session"
export const PAYMENT_PROCESSOR_BASE_KEY = "paymentProcessor"
export const SETUP_INTENT_BASE_KEY = "setupIntent"
export const CONFIRM_SETUP_INTENT_BASE_KEY = "confirmSetupIntent"
export const PAYMENT_INTENT_BASE_KEY = "paymentIntent"
export const CONFIRM_PAYMENT_BASE_KEY = "confirmPayment"
export const GET_CONFIRMATION_DETAILS_BASE_KEY = "getConfirmationDetails"
export const CHECKOUT_BASE_KEY = "checkout"
export const SESSION_DETAILS_BASE_KEY = "sessionDetails"
export const RATES_BASE_KEY = "rates"
export const PASSES_FOR_SALE_BASE_KEY = "passesForSale"
export const PURCHASE_PASS_BASE_KEY = "purchasePass"
export const SESSIONS_BASE_KEY = "sessions"
export const VALID_PASSES_BASE_KEY = "validPasses"

export const CALENDARS_BASE_KEY = "calendars"
export const RESERVE_CALENDAR_AVAILABILITY_BASE_KEY =
  "reserveCalendarAvailability"
export const RESERVE_RATES_BASE_KEY = "reserveRates"
export const RESERVE_CHECKOUT_BASE_KEY = "reserveCheckout"

export const RESERVE_CURRENT_RESERVATIONS_BASE_KEY =
  "reserveCurrentReservations"
export const RESERVE_PAST_RESERVATIONS_BASE_KEY = "reservePastReservations"

// MEMBERSHIPS
export const MEMBERSHIPS_BASE_KEY = "memberships"

// USER
export const ME_BASE_KEY = "mua"
export const SAVED_PAYMENT_METHODS_BASE_KEY = "savedPaymentMethods"
export const SAVED_PAYMENT_METHODS_WALLET_INTENT =
  "savedPaymentMethodWalletIntent"
